var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"upscale-factor-slider"},[_c('runnit-dynamic-field-label-row',{attrs:{"field":_vm.field,"label-styles":{
			padding: '0 0 4px 0',
		},"adminOnly":_vm.adminOnly}}),(_vm.hasOptions)?_c('slider-select',{attrs:{"value":_vm.value,"items":_vm.sliderOptions,"rules":[
			...(_vm.field.required ? _vm.rules.requiredNumberField : _vm.rules.optionalNumberField),
			..._vm.upscaleFactorRules
		]},on:{"input":_vm.onFieldInput}}):_c('base-slider',{attrs:{"value":_vm.value,"max":_vm.field.display.max || 4,"min":_vm._isNil(_vm.field.display.min) ? 1 : _vm.field.display.min,"step":_vm.field.display.step || 0.1,"rules":[
			...(_vm.field.required ? _vm.rules.requiredNumberField : _vm.rules.optionalNumberField),
			..._vm.upscaleFactorRules
		],"hide-details":"","editable-number-input":""},on:{"input":_vm.onFieldInput}}),(_vm.finalResolution)?_c('div',{staticClass:"final-resolution-display",class:{
			'exceeds-limit': _vm.exceedsMaxDimension
		},style:({
			marginRight: _vm.hasOptions ? '0px' : '100px',
		})},[_vm._v(" Final Resolution: "+_vm._s(_vm.finalResolution)+" "),(_vm.exceedsMaxDimension)?_c('div',{staticClass:"warning-text"},[_vm._v(" (Exceeds max dimensions of "+_vm._s(_vm.maxWidth)+"x"+_vm._s(_vm.maxHeight)+"px) ")]):_vm._e()]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }